import { LatLngExpression } from 'leaflet'
import { Shipments } from 'types/api/delivery'
import { ORDER_STATUS } from 'types/api/order'

export interface DeliveryShipment extends Shipments {
  orderIds: string[]
  color: string
  routeName: string
  routePolygons?: LatLngExpression[] | LatLngExpression[][]
  midPoints: LatLngExpression[] | null
  routeIsInPlanning: boolean
  deliveryCrc: string
  masterShipmentId: number
  masterShipmentCrc: string
  shipmentStartTime: string | null
  shipmentEndTime: string | null
  deliveryStartTime: string | null
  orderStatus: Partial<ORDER_STATUS>
}

export interface DeliverySlot {
  type: string
  id: number
  endTime: string
  startTime: string
  validityStart: string
  date: string
  orderQuota: number
  deliveryPrice: string
  product?: {
    extraProduct: string
    name: string
  }
  attributes: string[]
}

export interface PickupSlot {
  id: number
  type: string
  endTime: string
  startTime: string
  validityStart: string
  date: string
  orderQuota: number
  deliveryPrice: string
  pickupLocationId: number
  product?: {
    extraProduct: string
    name: string
  }
}

// for some reason retrieving all pickup slots shows startsAt and endsAt but a single slot shows startTime and endTime
export interface SlotDetails {
  type: string
  id: number
  endTime: string
  startTime: string
  date: string
  orderCount: number
  orderQuota: number
  deliveryPrice: string
  pickupLocationId: number
  graceHours: number
  visibilityStart: string
  visibilityEnd: string
  validityStart: string
  validityEnd: string
  active: boolean
  product?: {
    masterProductId: number
    extraProduct: string
    name: string
    price: { price: number }
  }
  attributes?: string[]
}

export enum TRACKING_EVENT {
  ADD_TO_ROUTE = 'add_to_route',
  SAVING_ROUTE_CHANGES = 'saving_route_changes',
  REORDER_ROUTE = 'reorder_route',
  CREATE_NEW_ROUTE = 'create_new_route',
  REMOVE_FROM_ROUTE = 'remove_from_route',
  CHANGE_ROUTE_START_TIME = 'change_route_start_time',
  DELETE_ROUTE = 'delete_route',
}

export const ASAP_SLOT = 'ASAP'
